export const Faqs = [
  {
    q: "Can I apply to be a Cloud Worker?",
    a: "If you’re a Nepali Citizen and above 18 yrs, you are eligible to apply. Having access to computer and internet is a must since this is an online work. And of course willingness to work in a team and openness to grow yourself with us is an added path to success.",
  },

  {
    q: "How can I be a Cloud Worker?",
    a: "If you’re eligible, being a Cloud Worker is really simple. After few steps of hiring process, you will be called for training and once you pass the assessment, you can start earning right away. Learn more about our hiring process.",
  },

  {
    q: "Is CloudFactory a good fit for me?",
    a: "If you enjoy doing data entry micro tasks, looking for a flexible job and willing to invest yourself to be future leaders, we’re the right place for you and yes, we need you.",
  },

  {
    q: "How is CloudFactory different from other Online jobs provider?",
    a: "At CloudFactory, you are important and we want you to grow. Even though you start with a simple data entry job, we invest in you to make sure you’re growing every day in what you do. We have a full time staff dedicated towards hearing you and helping you with every stage as you learn and grow.. We believe leadership = character x community x competency. We want to become and raise up leaders worth following, those of high character and competency who believes in giving back to the community for a purpose bigger than oneself.",
  },

  {
    q: "Why do I need to be in teams?",
    a: "If you want to go fast, go alone. If you want to go far, go together. “ This African proverb reminds us of the power of teams and we want you to experience that with your fellow cloud workers. We believe that you in a team environment shall accelerate the process of your being leaders in your community.",
  },

  {
    q: "Do I need to meet with CloudFactory full time staff or come to the office location?",
    a: "Yes, we would love to know you and see you in person frequently. After all, you are a part of the CloudFactory cloud team. We conduct team meetings periodically and the goal of team meetings is to learn and grow together, while sharing unique perspectives towards our lessons. The lessons mainly focus on Personal Development Plan covering various aspects of 3Cs – Character, Competency and Community.",
  },

  {
    q: "What kind of online data work do I need to do?",
    a: "CloudFactory provides a variety of data entry jobs such as data extraction from images or documents, audio transcription, data moderation, data analysis, and much more.",
  },

  {
    q: "Do I need to pay to attend trainings? Do you train online?",
    a: "Of course, not! Depending on the tasks type, trainings could be in-person or online. Most of our trainings are in-person to promote team interaction and instant feedback. Our trainings are very practice oriented to help equip you with all the necessary skills.",
  },

  {
    q: "Is there a time scheduled to do the tasks or can I do it at my own time?",
    a: "The work hours are flexible and allows you to attempt the tasks at your own convenient schedule. However, some projects have peak hours, when the volume of tasks flowing in is higher than others. We ensure proper communication of those so that you can arrange accordingly.",
  },

  {
    q: "How and when will I be paid?",
    a: "Your earnings is reflected in USD in our platform, which gets converted to NRs as per the exchange rate during the payment week. Your payout will be deposited to your Prabhu Bank account, which can be located anywhere in your city. The payment is made after two weeks of the work week to ensure reviews are done. For example, The earnings of work week 1 is paid to you at the end of week 3. The earnings of work week 2 is paid to you at the end of week 4 and so on. You will have a continuous weekly earnings after the first three weeks of joining CloudFactory.",
  },
];
